import { render, staticRenderFns } from "./add-remarks-form.vue?vue&type=template&id=0e773a3c&"
import script from "./add-remarks-form.vue?vue&type=script&lang=js&"
export * from "./add-remarks-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports